export enum AbreCuentasRoutesEnum {
  TRY_AGAIN_LATER_ERROR = 'error-try-later' as any,
  ERROR_INCOMPATIBLE_BROWSER = 'error-navegador-incompatible' as any,
  PERMISSION_REQUIRED = 'permiso-requerido' as any,
  CAMERA_ERROR = 'error-camara' as any
}
